'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _class, _temp;

var _components = require('../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReservePopover = require('../../components/Popovers/ReservePopover');

var _ReservePopover2 = _interopRequireDefault(_ReservePopover);

var _StatusBannerMessage = require('./StatusBannerMessage');

var _StatusBannerMessage2 = _interopRequireDefault(_StatusBannerMessage);

var _StatusBanner = require('./StatusBanner.scss');

var _StatusBanner2 = _interopRequireDefault(_StatusBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RibbonPopover = (0, _jsx3.default)(_ReservePopover2.default, {
    id: 'ribbonReservePopover',
    styles: _StatusBanner2.default
});

var leadingMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'you_are_the_leading_bidder'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'increase_your_chances'
    }),
    iconName: 'check-circle'
});
var outBidMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    alert: true,
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'you_have_been_outbid'
    }),
    iconName: 'exclamation-circle'
});
var registeredMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    alert: true,
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'registration_pending'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'well_send_you_an_email'
    }),
    iconName: 'hourglass-start'
});
var registrationDeclinedMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    alert: true,
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'registration_declined'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'auctioneer_has_declined_registration'
    }),
    iconName: 'exclamation-circle'
});
var reserveMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    alert: true,
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'reserve_not_met_bidder_message'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'reserve_bid_has_been_recorded',
        values: { reserve: RibbonPopover }
    }),
    iconName: 'exclamation-circle'
});
var approvedMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'approved_to_bid'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'you_can_bid_on_any_of_the_items'
    }),
    iconName: 'check-circle'
});
var requestMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'request_submitted'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'request_submitted_long'
    }),
    iconName: 'check-circle'
});

var StatusBanner = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(StatusBanner, _Component);

    function StatusBanner() {
        (0, _classCallCheck3.default)(this, StatusBanner);
        return (0, _possibleConstructorReturn3.default)(this, (StatusBanner.__proto__ || (0, _getPrototypeOf2.default)(StatusBanner)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusBanner, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['bidderHasHighBid', 'catalogId', 'itemId', 'registrationStatus']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                bidderHasBid = _props.bidderHasBid,
                bidderHasHighBid = _props.bidderHasHighBid,
                bidderHasMetReserve = _props.bidderHasMetReserve,
                catalogId = _props.catalogId,
                catalogStatus = _props.catalogStatus,
                className = _props.className,
                isCatalogOnly = _props.isCatalogOnly,
                isLocked = _props.isLocked,
                itemId = _props.itemId,
                openDownloadMobileModal = _props.openDownloadMobileModal,
                openAbstenteeBidModal = _props.openAbstenteeBidModal,
                registrationStatus = _props.registrationStatus;
            var approved = registrationStatus.approved,
                declined = registrationStatus.declined,
                pending = registrationStatus.pending;


            var banner = '';
            if (declined) {
                banner = registrationDeclinedMessage;
            } else if (isCatalogOnly && !bidderHasBid && pending) {
                banner = requestMessage;
            } else if (bidderHasHighBid && !bidderHasMetReserve) {
                banner = reserveMessage;
            } else if (bidderHasHighBid && bidderHasMetReserve) {
                banner = leadingMessage;
            } else if (!bidderHasBid && pending) {
                banner = registeredMessage;
            } else if (bidderHasBid && !bidderHasHighBid) {
                banner = outBidMessage;
            } else if (!itemId && approved) {
                banner = approvedMessage;
            }

            var watchButton = (0, _jsx3.default)(_components.BidConsoleOpener, {
                catalogId: catalogId
            }, void 0, (0, _jsx3.default)(_components.Button, {
                primary: true,
                className: _StatusBanner2.default.button
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'watch_live_auction'
            })));
            var bidButton = (0, _jsx3.default)(_components.Button, {
                primary: true,
                className: _StatusBanner2.default.button,
                onClick: function onClick() {
                    return openAbstenteeBidModal(itemId, 0);
                }
            }, void 0, '\xA0', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'increase_bid'
            }));
            var isCatalog = !itemId;
            var button = void 0;

            if (isCatalog) {
                if (catalogStatus === 'live') {
                    button = watchButton;
                }
            } else if (!isCatalog) {
                if (bidderHasBid && !isLocked && !declined) {
                    button = bidButton;
                } else if (catalogStatus === 'live') {
                    button = watchButton;
                }
            }

            return (0, _jsx3.default)('div', {
                className: _StatusBanner2.default['status-banner'] + ' ' + className
            }, void 0, (0, _jsx3.default)('div', {
                className: _StatusBanner2.default.cta
            }, void 0, (0, _jsx3.default)('div', {
                className: _StatusBanner2.default.container
            }, void 0, (0, _jsx3.default)('span', {
                className: _StatusBanner2.default.link,
                onClick: openDownloadMobileModal
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'download_our_app'
            })), (0, _jsx3.default)('span', {
                className: _StatusBanner2.default['cta-text']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'and_get_bid_notifications'
            })))), (0, _jsx3.default)('div', {
                className: _StatusBanner2.default['leading-bidder-bar']
            }, void 0, banner, (0, _jsx3.default)('div', {
                className: _StatusBanner2.default['button-container']
            }, void 0, button), (0, _jsx3.default)('div', {
                className: _StatusBanner2.default['bid-live-message']
            }, void 0, (0, _jsx3.default)(_caterwaulComponents.Icon, {
                name: 'lightbulb-o',
                className: _StatusBanner2.default.light
            }), (0, _jsx3.default)('span', {
                className: _StatusBanner2.default.message
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bid_in_the_live_auction'
            })))));
        }
    }]);
    return StatusBanner;
}(_react.Component), _class.defaultProps = {
    bidderHasBid: false,
    bidderHasHighBid: false,
    bidderHasMetReserve: false,
    catalogId: 0,
    catalogStatus: '',
    className: '',
    isCatalogOnly: false,
    isLocked: false,
    itemId: 0,
    registrationStatus: {}
}, _temp);
exports.default = StatusBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/StatusBanner/StatusBanner.js
// module id = Lvxz
// module chunks = 46